import { LoginInfo, GetUserInfo } from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

const endPoint = 'auth/login';
const endPointMe = 'auth/me';
const endPointLogout = 'auth/logout';

export interface PutOrPostResponse {
  status: number;
}

export const postLogin = async (params: LoginInfo): Promise<GetUserInfo> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(params),
    contentType: 'application/json',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const getMe = async (): Promise<GetUserInfo> => {
  const url = getApiUrl(endPointMe);
  const header = getHeader({ method: 'GET' });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const postLogout = async (): Promise<PutOrPostResponse> => {
  const url = getApiUrl(endPointLogout);
  const header = getHeader({
    method: 'POST',
    contentType: 'application/json',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return { status: response.status };
};
